<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<template>
  <div
    v-if="isReady"
    id="register-app"
    :class="{
      'register-mobile': isMobile,
      'register-wpsoffice': isWpsoffice,
    }"
  >
    <Header v-if="headerShow" />
    <template v-if="$initRouteVueMode">
      <router-view v-show="contentShow" />
    </template>
    <component v-else v-show="!loadingShow" :is="targetComponent" />
    <div v-if="spinShow" class="mask">
      <Spin :class="$style['spin']" size="large" :tip="$t('093fa0fb74')" />
    </div>
    <PCLogin />
    <Spin v-if="loadingShow" :id="$style['loading-wrap']" size="large" />
    <SwitchAccount></SwitchAccount>
  </div>
</template>
<script lang="ts">
import i18n from "@/i18n";
import {
  onBeforeMount,
  computed,
  getCurrentInstance,
  ref,
  watch,
  defineComponent,
} from 'vue'
import useStore from '@hooks/useStore'
import { isLogin, Account } from '@store/modules/user/constants'
import { Spin } from 'ant-design-vue'
import {
  loginAction,
  isMobile as getIsMobile,
  getUtmSource,
  getQuery,
} from '@util/index'
import {
  isWPSClient as getIsWPSClient,
  isWPSClient,
  removeRegisterLogin,
} from '@util/wpsoffice'
import { getBusinessGuideStatus } from '@src/util/business'
import { routes } from './router'
const PCLogin = () => import('@component/PCofficeLogin/index.vue')
const Header = () => import('@component/Header/index.vue')
const SwitchAccount = () => import('@component/SwitchAccount/index.vue')

const HEADER_NAME: string = 'title'

export default defineComponent({
  components: {
    Spin,
    PCLogin,
    Header,
    SwitchAccount,
  },
  setup() {
    console.log(routes, '路由')
    const vm = getCurrentInstance()
    const spinShow = ref(false)
    const contentShow = ref(false)
    const loadingShow = ref(true)
    const isReady = ref(false)
    const isBusinessGuideStatus = getBusinessGuideStatus()
    const isMobile = getIsMobile() && !isBusinessGuideStatus
    const isWpsoffice = getIsWPSClient()
    const store = useStore(vm)
    console.log(routes, '路由11', store?.state.user)
    const loginState = computed(() => store?.state?.user.USER_isLogin)
    const hideComponents = store?.state?.HideComponents
    const headerShow = computed(
      () => window.$initRouteVueMode && !hideComponents.includes(HEADER_NAME)
    )

    const targetComponent = computed(() => {
      if (!window.$initRouteVueMode) {
        const findRoute: any = routes.find(
          (item: any) => item.name === window.$regPlatformTargetPage
        )
        return findRoute?.component
      }
      return null
    })

    // methods
    const login = isSkipLogin => store.dispatch(isLogin, isSkipLogin)
    // 动态加载
    if (isMobile) {
      console.log('日志-mobile')
      import('@assets/common.mobile.scss')
    } else {
      console.log('日志-pc')
      import('@assets/common.scss')
    }
    watch(loginState, function (newVal) {
      // 巨量渠道登录态上报
      if (newVal === true || newVal === false) {
        if (
          location.pathname.toLowerCase() === '/createguide' &&
          getQuery('utm_source') === 'feedsads' &&
          getQuery('utm_medium') === 'oceanengine'
        ) {
          // setuserid
          vm?.proxy.$report.report(
            'oceanengine_switch_account',
            {
              state: newVal ? 'success' : 'fail',
              url: location.href,
              company_id: vm?.proxy.$store.state.user[Account]?.companyid,
              user_id: vm?.proxy.$store.state.user[Account]?.userid,
              source: getQuery('utm_source'),
              medium: getQuery('medium'),
              campaign: getQuery('campaign'),
              content: getQuery('content'),
              term: getQuery('term'),
            },
            'server'
          )
        }
      }
      // 巨量渠道登录态上报 - 数据测试无误后可整块移除

      if (newVal === true) {
        spinShow.value = false
        window.logic.addUser(vm?.proxy.$store.state.user[Account]?.userid)
      }
    })
    onBeforeMount(async () => {
      window.logic.report('register_show', i18n.t('b383b136f4'), 'USER');
      isReady.value = true
      // 商业版引导状态入参或携带token游客创建，如果是，则支持不检查登录状态流程，支持游客状态流程
      login(isBusinessGuideStatus)
      if (vm && vm.proxy.$eventHub) {
        vm.proxy.$eventHub.$on('COMPONENT-LOADED', () => {
          loadingShow.value = false
          contentShow.value = true
        })
        vm.proxy.$eventHub.$on('LOADING', () => {
          loadingShow.value = true
        })
        vm.proxy.$eventHub.$on('LOADING-COMPLATE', () => {
          loadingShow.value = false
        })
      }
      const source: any = getUtmSource()
      if (
        ['pcoffice', 'macoffice', 'WPS365_PC'].includes(source) &&
        ~location.href.indexOf('utm_medium=save')
      ) {
        loadingShow.value = false
      }

      // 离开页面销毁客户端事件
      if (isWPSClient()) {
        window.addEventListener('beforeunload', event => {
          removeRegisterLogin()
        })
      }
    })
    return {
      spinShow,
      contentShow,
      headerShow,
      loadingShow,
      isMobile,
      isWpsoffice,
      isReady,
      targetComponent,
    }
  },
})
</script>
<style lang="scss">
#register-app {
  line-height: 1;
  font-size: 14px;
  font-family: Microsoft YaHei, Helvetica Neue, Helvetica, Arial, PingFang SC,
    Hiragino Sans GB, Heiti SC, WenQuanYi Micro Hei, sans-serif;
  /*min-height: 100vh;*/
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

@media screen and (max-width: 768px) {
  #register-app {
    background: #fff;
  }
}
@media screen and (max-width: 1036px) {
  #register-app {
    background: #fff;
  }
}
</style>
<style lang="scss" module>
.mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  .spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
#loading-wrap {
  position: fixed;
  left: 50%;
  top: 43%;
  font-size: 36px;
  width: 36px;
  height: 36px;
  margin-left: -18px;
  margin-top: -18px;
}
</style>
